import { render } from "./VariablesForm.vue?vue&type=template&id=5b5411a6"
import script from "./VariablesForm.vue?vue&type=script&lang=js"
export * from "./VariablesForm.vue?vue&type=script&lang=js"

import "./VariablesForm.vue?vue&type=style&index=0&id=5b5411a6&lang=scss"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__